import { Link } from "react-router-dom";
import type { PendingCompany } from "../../../api/pendingCompanies.service";
import { ROUTES } from "../../../routes";
import styles from "./Review.module.css";

export function ResolvedCompany({ record }: { record: PendingCompany }) {
  if (record.status !== "approved" || !record.companyId || !record.resolvedCompanyName)
    return <>—</>;
  return (
    <div className={styles.resolvedCompany}>
      <Link
        className={styles.companyLink}
        to={`${ROUTES.websiteUsers.companies}?companyId=${encodeURIComponent(record.companyId)}`}
        onClick={event => event.stopPropagation()}
      >
        {record.resolvedCompanyName}
      </Link>
      {record.resolutionKind && (
        <span className={styles.resolutionKind}>
          {record.resolutionKind === "created_new" ? "Created new" : "Linked existing"}
        </span>
      )}
    </div>
  );
}
